import { UseQueryOptions, UseQueryResult, useQuery } from 'react-query';

import { Participant, ParticipantMedicalInterview } from '@breathelife/types';

import ApiService from '../../Services/ApiService';
import { QueryId } from '../common/common.types';

export function useFetchParticipantsUnderwritingRequirementsQuery(
  applicationId?: string,
  options?: UseQueryOptions<Participant[]>,
): UseQueryResult<Participant[]> {
  return useQuery<Participant[]>(
    [QueryId.underwritingRequirementsPerParticipant, applicationId],
    async () => {
      if (!applicationId) {
        return Promise.reject(new Error('Application id is missing.'));
      }
      return await ApiService.fetchParticipantsUnderwritingRequirements(applicationId);
    },
    options,
  );
}

export function useFetchParticipantsWithMedicalInterviewQuery(
  applicationId?: string,
  options?: UseQueryOptions<Participant[]>,
): UseQueryResult<Participant[]> {
  return useQuery<Participant[]>(
    [QueryId.participants, applicationId],
    async () => {
      if (!applicationId) {
        return Promise.reject(new Error('Application id is missing.'));
      }
      return await ApiService.fetchParticipantsMedicalInterview(applicationId);
    },
    { ...options },
  );
}

export function useFetchParticipantMedicalInterviewQuery(
  participantId: string,
  options?: UseQueryOptions<ParticipantMedicalInterview>,
): UseQueryResult<ParticipantMedicalInterview> {
  return useQuery<ParticipantMedicalInterview>(
    [QueryId.participantMedicalInterview, participantId],
    async () => {
      return await ApiService.fetchParticipantMedicalInterview(participantId);
    },
    options,
  );
}
